import React, { Fragment, useState, useEffect } from 'react';
import { NavLink, RouteComponentProps } from 'react-router-dom';
import _ from 'lodash';
import Button from 'components/Button';
import { Collapse } from 'components/Transition';
import classlist from 'utils/classlist';
import { UI } from 'stores/ui';

import Accordion from '../../../components/Accordion';

import './style.scss';

interface SideMenuProps {
    data: any;
    ui: UI;
}

const SideMenu: React.FC<SideMenuProps & RouteComponentProps<{ main: string; sub?: string }>> = props => {
    const [show, setShow] = useState(false);
    const { main, sub } = props.match.params;

    useEffect(() => {
        const handler = () => {
            if (window.innerWidth <= 768 && show) {
                setShow(false);
            }
        };

        document.addEventListener('click', handler, false);

        try {
            if ('matchMedia' in window) {
                const mql = window.matchMedia('(max-width: 768px)');

                mql.addListener(() => {
                    setShow(!show);
                });
            }
        } catch (error) {
            //
        }

        return () => {
            document.removeEventListener('click', handler, false);
        };
    }, [show]);

    function render() {
        // props.data.items 外层已经统一处理了 这里就不需要异常判断了
        const data = _.find(props.data.items, item => String(item.link_code) === String(main));
        const subData = data.children && _.find(data.children, subItem => String(subItem.id) === String(sub));

        return (
            <Fragment>
                <Collapse in={show} direction="h">
                    <nav className={classlist('nav-menu', props.ui.isTiger && 'fixed-t-0')}>
                        <div className="menu-container">
                            {props.data.items.map((item, index) => {
                                return (
                                    <Accordion
                                        key={index}
                                        title={
                                            <div
                                                className="title"
                                                onClick={e => {
                                                    e.nativeEvent.stopImmediatePropagation();
                                                }}>
                                                {item.title}
                                            </div>
                                        }
                                        children={item.children.map((subItem, i) => {
                                            return (
                                                <div key={i} className="link-box">
                                                    <NavLink
                                                        to={`/help/${item.link_code}/${subItem.id}`}
                                                        title={subItem.title}>
                                                        {subItem.title}
                                                    </NavLink>
                                                </div>
                                            );
                                        })}
                                        open={item.link_code === main}
                                    />
                                );
                            })}
                        </div>
                    </nav>
                </Collapse>
                <div className="menu-switch">
                    <Button
                        className="switch-btn"
                        onClick={ev => {
                            setShow(!show);
                            ev.nativeEvent.stopImmediatePropagation();
                        }}>
                        <span className="icon">icon</span>
                        SHOW SIDE NAVIGATION
                    </Button>
                </div>
                <div className="current-title">{subData && subData.title}</div>
            </Fragment>
        );
    }

    return <div className="side-menu-root">{render()}</div>;
};

export default SideMenu;
